import React from 'react'
import {
	CardItemContainer,
	IconContainer,
	InformationContainer,
	Text,
} from './CardItem.styles'
import { ReactComponent as ChecklistIcon } from 'App/assets/checklist-icon.svg'
import { ReactComponent as EditIcon } from 'App/assets/edit-icon.svg'
import { ReactComponent as SentIcon } from 'App/assets/sent-icon.svg'
import { format } from 'date-fns'

interface ICardItem {
	title: string
	description: string
	status: string
}

export const CardItem = ({
	title,
	description,
	status,
}: ICardItem): JSX.Element => {
	const formattedDate = format(
		new Date(description).setHours(12, 0, 0, 0),
		'dd/MM/yyyy',
	)

	const getText = () => {
		return status === 'done'
			? `Enviado el ${formattedDate}`
			: `Fecha límite ${formattedDate}`
	}

	const getIconColor = () => {
		return status !== 'done' && status === 'locked' ? '#D8DEE6' : '#64778F'
	}

	return (
		<CardItemContainer>
			<div>
				<ChecklistIcon />
			</div>
			<InformationContainer>
				<Text variant>{title}</Text>
				<Text>{getText()}</Text>
			</InformationContainer>
			<IconContainer color={getIconColor()}>
				{status === 'done' ? <SentIcon /> : <EditIcon />}
			</IconContainer>
		</CardItemContainer>
	)
}
